import { FormExtractorService } from "../../../shared/services/form-extractor.service";
import { LogService } from "../../../shared/services/log.service";
import { Validator } from "../../../shared/services/validator";
import { CTRL_NAME_EXTRACTOR } from "../ctrl.name.extractor";

export class CTRL_525u2 implements Validator {

    public static id = 'CTRL_525u2';
    private message = 'error.ctr_525';


    public LOG: LogService = new LogService(CTRL_525u2);
    public formExtractorService: FormExtractorService = new FormExtractorService();

    
    validate(form: any, map) {

        
        // vérifier si la règle est applicable sur mon formulaire
        const rgs: string[] = CTRL_NAME_EXTRACTOR.getCtrlNames(form, CTRL_525u2.id + '_');

        if (rgs.length > 0) {
            for (var rg of rgs) {
                const ctrl = form.controls[rg];
                const valeurBasseNameWithStepId = map.get(ctrl.value.rgCtrls.valeurBasse);
                const valeurHauteNameWithStepId = map.get(ctrl.value.rgCtrls.valeurHaute);
                const valeurBasseCtrl = form.controls[valeurBasseNameWithStepId];
                const valeurHauteCtrl = form.controls[valeurHauteNameWithStepId];

                if ((!this.isEmptyOrNullOrUndefined(valeurBasseCtrl.value) && this.isEmptyOrNullOrUndefined(valeurHauteCtrl.value)) ||
                    (this.isEmptyOrNullOrUndefined(valeurBasseCtrl.value) && !this.isEmptyOrNullOrUndefined(valeurHauteCtrl.value))) {
                    // placer le message d'erreur
                    form.controls[rg].value = { rgCtrls: ctrl.value.rgCtrls, ctrlValidation: true, validation_message: this.message };
                } else {
                    form.controls[rg].value = { rgCtrls: ctrl.value.rgCtrls, ctrlValidation: false };
                }
            }
        }
    }

    isEmptyOrNullOrUndefined(value): boolean{
		return (value === undefined || value === null || value === '');
	}
}
